import Titulo from '../../components/tipografia/Titulo';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import Descricao from '../../components/tipografia/Descricao';
import HBox from '../../components/layout/HBox';
import VBox from '../../components/layout/VBox';
import { useEffect, useState, useCallback } from 'react';
import CampoSeletor from '../../components/Formulario/CampoSeletor';
import Grid, { GridItem } from '../../components/layout/Grid';
import CampoData from '../../components/Formulario/CampoData';
import {
  format,
  startOfDay,
  startOfWeek,
  startOfMonth,
  startOfYear,
} from 'date-fns';
import CardRelatorio from './CardRelatorio';
import Valor from './Valor';
import CardRelatorioTotalClientesAtendidos from './CardRelatorioTotalClientesAtendidos';
import FiltroCanal from '../../components/Filtros/FiltroCanal';
import CardRelatorioTotalCDA from './CardRelatorioCDA';
import CardRelatorioTotalAtendimentos from './CardRelatorioTotalAtendimentos';
import CardRelatorioTotalAtendimentosHumanos from './CardRelatorioTotalAtendimentosHumanos';
import CardRelatorioTotalMensagens from './CardRelatorioTotalMensagens';
import CardRelatorioTotalNotificacoes from './CardRelatorioTotalNotificacoes';
import Subtitulo from '../../components/tipografia/Subtitulo';
import FiltroGrupoUsuario from '../../components/Filtros/FiltroGrupoUsuario';
import { GraficoSLAAtendentes2 } from './GraficoSLAAtendentes2';
import { GraficoTempoResposta } from './GraficoTempoResposta';
import { GraficoDesempenhoAtendentes } from './GraficoDesempenhoAtendentes';
import HistogramaMensagens from './HistogramaMensagens';
import { GraficoMarcadores } from './GraficoMarcadores';
import CardRelatorioHistoricoSessao from './CardRelatorioHistoricoSessao';
import CardRelatorioAbandonoReengajamento from './CardRelatorioAbandonoReengajamento';
import { GraficoNPS } from './GraficoNPS';
import { GraficoSentimentoCliente } from './GraficoSentimentoCliente';
import { GraficoComportamentoAtendente } from './GraficoComportamentoAtendente';
import { GraficoEmocaoCliente } from './GraficoEmocaoCliente';
import { GraficoIntencaoPrincipal } from './GraficoIntencaoPrincipal';
import { GraficoIntencaoSecundaria } from './GraficoIntencaoSecundaria';
import Botao from '../../components/Botao';
import Icon from '@mdi/react';
import { mdiPrinter } from '@mdi/js';

const today = startOfDay(new Date());
const thisWeek = startOfWeek(new Date());
const thisMonth = startOfMonth(new Date());
const thisYear = startOfYear(new Date());

const filterPeriodoOptions = [
  { id: 'hoje', label: `Hoje (${today.toLocaleDateString()})` },
  {
    id: 'semana',
    label: `Esta semana (de ${thisWeek.toLocaleDateString()} até agora)`,
  },
  {
    id: 'mes',
    label: `Este mês (de ${thisMonth.toLocaleDateString()} até agora)`,
  },
  {
    id: 'ano',
    label: `Este ano (de ${thisYear.toLocaleDateString()} até agora)`,
  },
  { id: 'custom', label: 'Personalizado' },
];
type FilterPeriodoOption = (typeof filterPeriodoOptions)[number];
type FilterPeriodoOptionId = FilterPeriodoOption['id'];

type FilterProps = {
  periodo: [FilterPeriodoOptionId, string, string];
  grupo_id: number[];
  canal_id: number[];
};
type PageProps = {};

const colorPalette: string[] = [
  '#1b6336',
  '#4b9366',
  '#7bc396',
  '#abf3c6',
  '#211d71',
  '#514da1',
  '#817dd1',
  '#b1adff',
  '#985f00',
  '#c88f21',
  '#f8bf51',
  '#ffef81',
  '#2b4f4a',
  '#5b7f7a',
  '#8bafaa',
  '#bbdfda',
  '#985964',
  '#c88994',
  '#f8b9c4',
  '#ffe9f4',
  '#983e00',
  '#c86e00',
  '#f89e00',
  '#ffce29',
  '#4b6244',
  '#7b9274',
  '#abc2a4',
  '#dbf2d4',
];

const Page = ({ }: PageProps) => {
  const [filter, setFilter] = useState<FilterProps>({
    periodo: ['hoje', format(today, 'yyyy-MM-dd'), format(today, 'yyyy-MM-dd')],
    canal_id: [],
    grupo_id: [],
  });

  useEffect(() => {
    if (!filter.periodo[0]) return;

    switch (filter.periodo[0]) {
      case 'hoje':
        setFilter(p => ({
          ...p,
          periodo: [
            'hoje',
            format(today, 'yyyy-MM-dd'),
            format(today, 'yyyy-MM-dd'),
          ],
        }));
        break;
      case 'semana':
        setFilter(p => ({
          ...p,
          periodo: [
            'semana',
            format(thisWeek, 'yyyy-MM-dd'),
            format(today, 'yyyy-MM-dd'),
          ],
        }));
        break;
      case 'mes':
        setFilter(p => ({
          ...p,
          periodo: [
            'mes',
            format(thisMonth, 'yyyy-MM-dd'),
            format(today, 'yyyy-MM-dd'),
          ],
        }));
        break;
      case 'ano':
        setFilter(p => ({
          ...p,
          periodo: [
            'ano',
            format(thisYear, 'yyyy-MM-dd'),
            format(today, 'yyyy-MM-dd'),
          ],
        }));
        break;
    }
  }, [filter.periodo?.[0]]);

  // Função para imprimir a página de relatórios
  const handlePrintPage = useCallback(() => {
    window.print();
  }, []);

  return (
    <LayoutUsuario>
      <VBox gap="16px" style={{ height: 'calc(100vh - 32px)' }}>
        {/* Header */}
        <HBox>
          <VBox style={{ flex: 1 }}>
            <Titulo>Relatórios</Titulo>
            <Descricao>
              Visualize dados sobre clientes, atendentes, mensagens,
              notificações e mais
            </Descricao>
          </VBox>
          <div className="no-print">
            <Botao
              variant="outline-success"
              onClick={handlePrintPage}
              icon={mdiPrinter}
              title="Imprimir página de relatórios"
            >
              Imprimir Página
            </Botao>
          </div>
        </HBox>

        {/* Filtros */}
        <div className="no-print">
          <Grid>
            <GridItem sm={12} md={8} lg={6}>
              <HBox>
                <CampoSeletor
                  noSearch
                  options={filterPeriodoOptions}
                  placeholder="Pesquisar por período"
                  value={filter.periodo[0]}
                  onChange={value => {
                    setFilter({
                      ...filter,
                      periodo: [value!, filter.periodo[1], filter.periodo[2]],
                    });
                  }}
                  style={{
                    width: '100%',
                    flex: 1,
                  }}
                />
                {filter.periodo[0] == 'custom' && (
                  <CampoData
                    placeholder="Data inicial"
                    value={filter.periodo[1]}
                    onChange={value => {
                      setFilter({
                        ...filter,
                        periodo: [filter.periodo[0], value, filter.periodo[2]],
                      });
                    }}
                  />
                )}

                {filter.periodo[0] == 'custom' && (
                  <CampoData
                    placeholder="Data final"
                    value={filter.periodo[2]}
                    onChange={value => {
                      setFilter({
                        ...filter,
                        periodo: [filter.periodo[0], filter.periodo[1], value],
                      });
                    }}
                  />
                )}
              </HBox>
            </GridItem>
            <GridItem sm={12} md={4} lg={6}>
              <FiltroCanal
                value={filter.canal_id.map(it => it.toString())}
                onChange={value =>
                  setFilter({
                    ...filter,
                    canal_id: value.map(it => parseInt(it)),
                  })
                }
              />
            </GridItem>
          </Grid>
        </div>

        {/* Conteudo */}

        {/* Informações do relatório para impressão */}
        <div className="relatorio-info print-only" style={{ display: 'none' }}>
          <h3 style={{ margin: '0 0 0.5rem 0', color: '#333' }}>
            Dashboard de Relatórios - Terachat
          </h3>
          <div className="filtros-aplicados" style={{ fontSize: '0.9rem', color: '#666' }}>
            <strong>Período:</strong> {filter.periodo[1]} até {filter.periodo[2]} ({filter.periodo[0]})
          </div>
          {filter.canal_id.length > 0 && (
            <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.25rem' }}>
              <strong>Canais selecionados:</strong> {filter.canal_id.length} canal(is)
            </div>
          )}
          {filter.grupo_id.length > 0 && (
            <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.25rem' }}>
              <strong>Grupos selecionados:</strong> {filter.grupo_id.length} grupo(s)
            </div>
          )}
          <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.25rem' }}>
            <strong>Gerado em:</strong> {new Date().toLocaleString('pt-BR')}
          </div>
        </div>

        <Subtitulo>Mensagens e notificações</Subtitulo>
        <Grid>
          <GridItem sm={12} md={4} lg={2} p={4}>
            <CardRelatorioTotalClientesAtendidos
              periodo={filter.periodo}
              canal_id={filter.canal_id}
            />
          </GridItem>
          <GridItem sm={12} md={4} lg={2} p={4}>
            <CardRelatorioTotalAtendimentos
              periodo={filter.periodo}
              canal_id={filter.canal_id}
            />
          </GridItem>
          <GridItem sm={12} md={4} lg={2} p={4}>
            <CardRelatorioTotalAtendimentosHumanos
              periodo={filter.periodo}
              canal_id={filter.canal_id}
            />
          </GridItem>

          <GridItem sm={12} md={4} lg={2} p={4}>
            <CardRelatorioTotalMensagens
              periodo={filter.periodo}
              canal_id={filter.canal_id}
            />
          </GridItem>

          <GridItem sm={12} md={4} lg={2} p={4}>
            <CardRelatorioTotalNotificacoes
              periodo={filter.periodo}
              canal_id={filter.canal_id}
            />
          </GridItem>

          <GridItem sm={12} md={4} lg={2} p={4}>
            <CardRelatorioTotalCDA
              periodo={filter.periodo}
              canal_id={filter.canal_id}
            />
          </GridItem>

          <GridItem sm={12} md={6} lg={4} rows={4} p={6}>
            <CardRelatorio
              titulo="Marcadores"
              style={{ height: '360px' }}
              mostrarVisualizador={false}
              filtroVisualizador={filter}
              metricasVisualizador={[]}
              dimensoesVisualizador={[]}
              hrefVisualizador="/api/relatorios/marcadores"
            >
              <GraficoMarcadores
                colorPalette={colorPalette}
                periodo={filter.periodo}
                filterCanal={filter.canal_id}
              />
            </CardRelatorio>
          </GridItem>
          <GridItem sm={12} md={6} lg={4} rows={4} p={6}>
            <CardRelatorio
              titulo="Pontuação de atendimento"
              style={{ height: '360px' }}
              mostrarVisualizador={true}
              filtroVisualizador={filter}
              metricasVisualizador={['avg_score', 'qtd_pontuacoes']}
              dimensoesVisualizador={['rotulo', 'usuario_responsavel_nome']}
              hrefVisualizador="/api/relatorios/chat_pontuacao"
              notaVisualizador="O responsável é o último atendente humano do chat. Chats atendidos só pelo bot aparecem sem responsável."
              info="Média das pontuações de atendimento (NPS) recebidas no período."
              csv
            >
              <GraficoNPS colorPalette={colorPalette} filter={filter} />
            </CardRelatorio>
          </GridItem>
          <GridItem sm={12} md={6} lg={4} rows={4} p={6}>
            <CardRelatorio
              titulo="✨Sentimento do Cliente"
              style={{ height: '360px' }}
              mostrarVisualizador={true}
              filtroVisualizador={filter}
              metricasVisualizador={['total']}
              dimensoesVisualizador={[
                'data_criacao',
                'canal_tipo',
                'usuario_responsavel_nome',
                'sentimento_cliente',
                'motivo_sentimento',
              ]}
              hrefVisualizador="/api/relatorios/chat_sentimento"
              info="Média do sentimento do cliente (positivo, neutro ou negativo) em cada atendimento, com base nas interações com o atendimento humano."
            >
              <GraficoSentimentoCliente
                colorPalette={colorPalette}
                periodo={filter.periodo}
                filterCanal={filter.canal_id}
              />
            </CardRelatorio>
          </GridItem>
          <GridItem sm={12} md={6} lg={4} rows={4} p={6}>
            <CardRelatorio
              titulo="✨Comportamento do Atendente"
              style={{ height: '360px' }}
              mostrarVisualizador={true}
              filtroVisualizador={filter}
              metricasVisualizador={['total']}
              dimensoesVisualizador={[
                'data_criacao',
                'canal_tipo',
                'usuario_responsavel_nome',
                'comportamento_atendente',
                'motivo_comportamento',
              ]}
              hrefVisualizador="/api/relatorios/chat_comportamento"
              info="Média do comportamento do atendente (positivo, neutro ou negativo) em cada atendimento, com base nas interações com o cliente."
            >
              <GraficoComportamentoAtendente
                colorPalette={colorPalette}
                periodo={filter.periodo}
                filterCanal={filter.canal_id}
              />
            </CardRelatorio>
          </GridItem>
          <GridItem sm={12} md={6} lg={4} rows={4} p={6}>
            <CardRelatorio
              titulo="✨Emoção do Cliente"
              style={{ height: '360px' }}
              mostrarVisualizador={true}
              filtroVisualizador={filter}
              metricasVisualizador={['total']}
              dimensoesVisualizador={[
                'data_criacao',
                'canal_tipo',
                'usuario_responsavel_nome',
                'emocao_cliente',
              ]}
              hrefVisualizador="/api/relatorios/chat_resumo"
            >
              <GraficoEmocaoCliente
                periodo={filter.periodo}
                filterCanal={filter.canal_id}
              />
            </CardRelatorio>
          </GridItem>
          <GridItem sm={12} md={6} lg={4} rows={4} p={6}>
            <CardRelatorio
              titulo="✨Intenção Principal"
              style={{ height: '360px' }}
              mostrarVisualizador={true}
              filtroVisualizador={filter}
              metricasVisualizador={['total']}
              dimensoesVisualizador={[
                'data_criacao',
                'canal_tipo',
                'usuario_responsavel_nome',
                'intencao_principal',
              ]}
              info="Intenção principal é a intenção mais relevante do atendimento, inferida por IA, a partir das interações do cliente."
              hrefVisualizador="/api/relatorios/chat_resumo"
            >
              <GraficoIntencaoPrincipal
                colorPalette={colorPalette}
                periodo={filter.periodo}
                filterCanal={filter.canal_id}
              />
            </CardRelatorio>
          </GridItem>
          <GridItem sm={12} md={6} lg={4} rows={4} p={6}>
            <CardRelatorio
              titulo="✨Intenções Secundárias"
              style={{ height: '360px' }}
              mostrarVisualizador={true}
              filtroVisualizador={filter}
              metricasVisualizador={['total']}
              dimensoesVisualizador={[
                'data_criacao',
                'canal_tipo',
                'usuario_responsavel_nome',
                'intencao_principal',
                'intencao_secundaria',
              ]}
              info="Intenções secundárias são intenções adicionais do atendimento, inferidas por IA, a partir das interações do cliente."
              hrefVisualizador="/api/relatorios/chat_resumo"
            >
              <GraficoIntencaoSecundaria
                colorPalette={colorPalette}
                periodo={filter.periodo}
                filterCanal={filter.canal_id}
              />
            </CardRelatorio>
          </GridItem>
        </Grid>


        <Subtitulo>Atendimento</Subtitulo>
        <Grid>
          <GridItem sm={12}>
            <FiltroGrupoUsuario
              value={filter.grupo_id.map(it => it.toString())}
              onChange={v =>
                setFilter({ ...filter, grupo_id: v.map(it => parseInt(it)) })
              }
            />
          </GridItem>
        </Grid>

        <Grid>
          <GridItem sm={12} lg={4} rows={2}>
            <CardRelatorio
              titulo="Tempo médio até atendimento"
              style={{ height: '350px' }}
              mostrarVisualizador
              filtroVisualizador={filter}
              metricasVisualizador={['avg_sla_seconds']}
              dimensoesVisualizador={[
                'data_criacao_mes',
                'usuario_responsavel_nome',
              ]}
              hrefVisualizador="/api/relatorios/sla"
              info="Tempo médio em segundos que o cliente espera até receber atendimento humano"
            >
              <GraficoSLAAtendentes2
                periodo={filter.periodo}
                filterGrupo={filter.grupo_id}
                colorPalette={colorPalette}
              />
            </CardRelatorio>
          </GridItem>

          <GridItem sm={12} lg={4} rows={2}>
            <CardRelatorio
              titulo="Tempo médio de resposta"
              style={{ height: '350px' }}
              mostrarVisualizador
              filtroVisualizador={filter}
              metricasVisualizador={['avg_tempo_resposta_segundos']}
              dimensoesVisualizador={[
                'data_criacao_mes',
                'usuario_responsavel_nome',
              ]}
              hrefVisualizador="/api/relatorios/chat_mensagem"
              info="Tempo médio em segundos que o cliente espera para receber uma resposta"
            >
              <GraficoTempoResposta
                periodo={filter.periodo}
                filterGrupo={filter.grupo_id}
                colorPalette={colorPalette}
              />
            </CardRelatorio>
          </GridItem>

          <GridItem sm={12} lg={4} rows={2}>
            <CardRelatorioHistoricoSessao
              periodo={filter.periodo}
              canal_id={filter.canal_id}
              grupo_id={filter.grupo_id}
              colorPalette={colorPalette}
            />
          </GridItem>

          <GridItem sm={12} lg={4} rows={2}>
            <CardRelatorio
              titulo="Atendimentos humanos"
              style={{ height: '350px' }}
              mostrarVisualizador
              filtroVisualizador={filter}
              metricasVisualizador={['qtd_atendimentos_humanos']}
              dimensoesVisualizador={[
                'data_criacao_mes',
                'usuario_responsavel_nome',
              ]}
              hrefVisualizador="/api/relatorios/chat_mensagem"
              info="Quantidade de atendimentos humanos realizados, por atendente"
            >
              <GraficoDesempenhoAtendentes
                periodo={filter.periodo}
                filterGrupo={filter.grupo_id}
                colorPalette={colorPalette}
              />
            </CardRelatorio>
          </GridItem>

          <GridItem sm={12} lg={4} rows={2}>
            <CardRelatorioAbandonoReengajamento
              periodo={filter.periodo}
              canal_id={filter.canal_id}
              style={{ height: '350px' }}
            />
          </GridItem>

          <GridItem sm={12} rows={4}>
            <CardRelatorio
              titulo="Atividade durante o período"
              style={{ height: '360px' }}
              info="Mostra, em escala de cores, o período de maior atividade"
            >
              <HistogramaMensagens
                data={[]}
                seletor="mensagens"
                periodo={filter.periodo}
                canal_id={filter.canal_id}
                grupo_id={filter.grupo_id}
              />
            </CardRelatorio>
          </GridItem>
        </Grid>
      </VBox>
    </LayoutUsuario>
  );
};

export default Page;
